// Labels
export const EVENT_LABEL_SELECT_UNIT = (unitName: string) =>
  `selectstore - ${unitName}`
export const EVENT_LABEL_PRESELECT_UNIT = (unitName: string) =>
  `preselectstore - ${unitName}`
export const EVENT_LABEL_DESELECT_UNIT = (unitName: string) =>
  `deselectstore - ${unitName}`

export const EVENT_LABEL_CLEAR_ALL_FILTERS = 'clear_all_filters'

export const EVENT_LABEL_SELECT_CATEGORY = (categoryId: string) =>
  `cat - ${categoryId}`
export const EVENT_LABEL_DESELECT_CATEGORY = (categoryId: string) =>
  `deselectcategory - ${categoryId}`
export const EVENT_LABEL_SELECT_ALL_CATEGORIES = `cat - All categories`
export const EVENT_LABEL_SELECT_ITEM = (tagID: string, title: string) =>
  `selectitem - ${tagID} - ${title}`
export const EVENT_LABEL_SELECT_GROUPING_ITEM = ({
  firstOfferNumber,
  position,
  productName,
  offerNumber,
}: {
  firstOfferNumber: string
  position?: string
  productName: string
  offerNumber?: string
}) =>
  `selectgroupingitem${position ? ` - ${position}` : ''} - ${firstOfferNumber} - ${productName}${offerNumber ? ` - ${offerNumber}` : ''}`
export const EVENT_LABEL_CLOSE_GROUPING_ITEM = (
  offerNumber: string,
  productName: string
) => `closegroupingitem - ${offerNumber} - ${productName}`

export const EVENT_LABEL_SELECT_CONDITION = (code: string) =>
  `productcondition - ${code}`
export const EVENT_LABEL_DESELECT_CONDITION = (code: string) =>
  `deselectproductcondition - ${code}`
export const EVENT_LABEL_CLICK_TAB_IMAGE = (tagID: string, title: string) =>
  `Product - ${tagID} - ${title}`
export const EVENT_LABEL_CLICK_TAB_DEFECT = (tagID: string, title: string) =>
  `Defects - ${tagID} - ${title}`
export const EVENT_LABEL_CLICK_LOGIN = 'login_or_signup_to_reserve'
export const EVENT_LABEL_CLICK_CONTINUE_TO_RESERVATION =
  'continue_to_reservation'
export const EVENT_LABEL_CLICK_RESERVE_BUTTON = 'reserve_this_product'
export const EVENT_LABEL_CLICK_CONTINUE_SHOPPING = 'continue_shopping'
export const EVENT_LABEL_CLICK_SHOW_OPENING_HOURS = 'show_opening_hours'
export const EVENT_LABEL_CLICK_BACK_PLP_FROM_PIP = (
  tagID: string,
  title: string
) => `Return - ${tagID} - ${title}`
export const EVENT_LABEL_CLICK_BACK_TO_PIP = 'back_to_pip'
export const EVENT_LABEL_CLICK_SHOW_MORE = (currentPages: number) =>
  `show_more - ${currentPages}`
export const EVENT_LABEL_CLICK_SEARCH = (term: string) => `search - ${term}`
export const EVENT_LABEL_SEARCH_RESULTS = (term: string, resultCount: number) =>
  `search - ${term} - ${resultCount} results`
export const EVENT_LABEL_SEARCH_ZERO_RESULTS = (term: string) =>
  `search_zero_results - ${term}`
export const EVENT_LABEL_CLICK_QUESTION = 'send_message'
export const EVENT_LABEL_CLICK_PRODUCT_DETAILS = (productID: string | number) =>
  `pip product details - ${productID}`
export const EVENT_LABEL_CLICK_CTA_SELECT_SHOP = 'cta_select_a_store'
export const EVENT_LABEL_CLICK_PRODUCT_CONDITIONS = ({
  productID,
  conditionID,
}: {
  productID: string | number
  conditionID: string | number
}) => `product_condition - ${productID} - ${conditionID}`

export const EVENT_LABEL_RATING = (rating: number) => `rating_${rating}`
export const EVENT_LABEL_OPTION = (reason: string) => `rating_option_${reason}`

export const EVENT_LABEL_READMORE_INTRODUCTION = 'readmore - introduction'
export const EVENT_LABEL_READMORE_INSTRUCTION = 'readmore_instruction'
export const EVENT_LABEL_READMORE_HERO = 'readmore'
export const NOT_UNIT_SELECTED = 'Not store selected'

export const EVENT_LABEL_EXCEED_CONCURRENT_RESERVATION_LIMIT =
  'error_message_overbook_diff_offer'
export const EVENT_LABEL_EXCEED_OFFER_RESERVATION_LIMIT =
  'error_message_overbook_same_offer'

export const EVENT_LABEL_SELECT_SORT = (sortingType: string) =>
  `sort - ${sortingType}`

export const EVENT_LABEL_CANCEL_RESERVATION = (productID: string | number) =>
  `cancel_reservation - ${productID}`

export const EVENT_LABEL_BUYBACK_LINK_CLICK = 'buyback_link'
export const EVENT_LABEL_PREOWNED_LINK_CLICK = 'readmore_preownedlink'
export const EVENT_LABEL_PIP_REFERRAL = ({
  offerNumber,
  productName,
}: {
  offerNumber: string | number
  productName: string
}) => `selectitem - pip referral ${offerNumber} - ${productName}`

// Actions
export const EVENT_ACTION_CLICK = 'click'
